import { URI } from 'vscode/vscode/vs/base/common/uri';

class DownloadServiceChannel {
    constructor(service) {
        this.service = service;
    }
    listen(_, event, arg) {
        throw ( new Error('Invalid listen'));
    }
    call(context, command, args) {
        switch (command) {
            case 'download': return this.service.download(URI.revive(args[0]), URI.revive(args[1]));
        }
        throw ( new Error('Invalid call'));
    }
}

export { DownloadServiceChannel };
